<template>
  <section class="app-main">
    <!-- 整条路由渲染链（App.vue / Layout.vue / 本文件）都不能用过渡动画包裹路由出口，
         包在父级同样会死锁：它的 enter/leave 靠 requestAnimationFrame 推进，标签页不可见
         时 rAF 被冻结，路由切换会永久卡住（守卫见 tests/app-main-transition.test.js） -->
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>
